import script from "./HeaderChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderChatDialogsPanel.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderChatDialogsPanel.vue?vue&type=style&index=0&id=38fc4e77&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38fc4e77"]])

export default __exports__